export default __webpack_public_path__ + "static/media/jamie-portfolio-bg_converted.135ac6e9.jpg";